import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';

// types
import { DefaultRootStateProps } from 'types';

const initialState: DefaultRootStateProps['reports'] = {
    error: null,
    loading: false,
    changeLog: [],
    changeLogUsers: []
};

const reports = createSlice({
    name: 'reports',
    initialState,
    reducers: {},
    extraReducers(builder) {
        // CHANGE LOG
        builder
            .addCase(getChangeLogList.pending, (state) => {
                state.loading = true;
            })
            .addCase(getChangeLogList.fulfilled, (state, action) => {
                state.loading = false;
                state.changeLog = action.payload.response;
            })
            .addCase(getChangeLogUsers.pending, (state) => {
                state.loading = true;
            })
            .addCase(getChangeLogUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.changeLogUsers = action.payload;
            });
    }
});

export default reports.reducer;

export const getChangeLogList = createAsyncThunk(`${reports.name}/getChangeLogList`, async (idMerchant: number | null) => {
    const response = await axios.post(
        `/loolu/api/multicatalog/product/changelog`,
        {},
        {
            params: {
                idMerchant: idMerchant || 1
            }
        }
    );
    return response.data;
});

export const getChangeLogUsers = createAsyncThunk(`${reports.name}/getChangeLogUsers`, async (idMerchant: number | null) => {
    const response = await axios.get(`/loolu/api/logs/users`, {
        params: {
            idMerchant: idMerchant || 1
        }
    });
    return response.data;
});
